import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";
import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import {
    AdditionalForceData, ForceCascadeRequestPayload, ForceFreeSpinRequestPayload,
    ForcePayload, ForceRequestPayload, ForceRespinRequestPayload
} from "gamevy/integration/builders/requests/force-request-payload";
import { CascadeRequestPayload } from "slotworks/model/gameplay/requests/cascade-request-payload";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";
import { RespinRequestPayload } from "slotworks/model/gameplay/requests/respin-request-payload";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";

export enum ForceSpinType {
    SPIN, FREESPIN, CASCADE, RESPIN
}

export function getForcePayload(type: ForceSpinType, data?: AdditionalForceData): ForcePayload | RequestPayload {
    if (data) {
        let payload: ForcePayload;

        switch (type) {
            case ForceSpinType.CASCADE:
                payload = new ForceCascadeRequestPayload();
                break;

            case ForceSpinType.FREESPIN:
                payload = new ForceFreeSpinRequestPayload();
                break;

            case ForceSpinType.RESPIN:
                payload = new ForceRespinRequestPayload();
                break;

            default:
                payload = new ForceRequestPayload();
                (payload as ForceRequestPayload).creditPerLine = Services.bet.getCreditPerLine();
                (payload as ForceRequestPayload).creditSize = Services.bet.getCreditSize();
                break;
        }

        payload.data = data;

        return payload;
    } else {
        let payload: RequestPayload;

        switch (type) {
            case ForceSpinType.CASCADE:
                payload = new CascadeRequestPayload();
                break;

            case ForceSpinType.FREESPIN:
                payload = new FreespinRequestPayload();
                break;

            case ForceSpinType.RESPIN:
                payload = new RespinRequestPayload();
                break;

            default:
                payload = new SpinRequestPayload();
                (payload as SpinRequestPayload).creditPerLine = Services.bet.getCreditPerLine();
                (payload as SpinRequestPayload).creditSize = Services.bet.getCreditSize();
                break;
        }

        return payload;
    }
}

export function ForceSpinCommand(type: ForceSpinType, data?: AdditionalForceData): Contract<void> {
    const payload = getForcePayload(type, data);

    return commsManager.request(payload);
}
